import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * A padlocked, read-only display of a value the user cannot change here.
 *
 * Used for Asset Type (never selectable — the type is chosen at the entry point), a Program locked
 * because the project is being created from inside one, and a country fixed by program config.
 *
 * Distinct from `oes-read-only-display`, which renders a mode banner and no value.
 *
 * NOTE: this renders the value only. The backing form control still exists and stays disabled —
 * `getFormValues` reads `controls[x].value` directly, so removing the control would throw on
 * submit. The server, not this component, is the authority for anything it displays.
 */
@Component({
  selector: 'oes-locked-field',
  templateUrl: './locked-field.component.html',
  styleUrls: ['./locked-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LockedFieldComponent {
  /** Already-translated text to display. */
  @Input() value: string;
  /** Tooltip explaining why it cannot be edited. Optional. */
  @Input() tooltip: string;
}
